import { DomainDnsRecord } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { HelperText } from '@tribeplatform/react-ui-kit/HelperText'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { DnsRecordsTable } from '../DnsRecordsTable/index.js'

interface Props {
  domain: string
  dnsRecords: DomainDnsRecord[]
}
export const StatusTaken = ({ domain, dnsRecords }: Props) => {
  return (
    <div className="flex flex-col space-y-3">
      <HelperText status="error" highlighted>
        <Text>
          <T
            defaultMessage="Seems like {domain} is taken by another site. If you own this domain and believe this is an error, contact Bettermode support."
            id="Admin.DomainTransfer.Taken"
            values={{
              domain: <strong className="font-mono">{domain}</strong>,
            }}
          />
        </Text>
      </HelperText>
      <DnsRecordsTable dnsRecords={dnsRecords} />
    </div>
  )
}
